import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { IoGlobals } from '../ioglobals';


@Component({
    selector: 'app-view-file-mobile',
    templateUrl: './view-file-mobile.component.html',
    styleUrls: ['./view-file-mobile.component.css'],
})
export class ViewFileMobileComponent implements OnInit {

    public connect;

    public token = {
        viewFileMobile: "viewfilemobileInvoiceGetfile"
    }

    public data: any;

    public language: string = '';

    public isLoading: boolean = true;

    public type: number = 0;

    constructor(
        public routerAct: ActivatedRoute,
        public IO: IoGlobals,
        public snackBar: MatSnackBar,
    ) {
        this.connect = this.IO.result.subscribe((res: any) => {

            switch (res.token) {
                case this.token.viewFileMobile:
                    if (res.status == 1) {
                        this.data = res.data;
                        this.isLoading = false;
                        if (this.type == 1) {
                            this.IO.download(this.data.file_path, this.data.file_name)
                        }
                    } else {
                        this.snackBar.open(res.message, 'Close', { duration: 3000 });
                    }
                    break;

                default: break;
            }
        });
    }

    ngOnInit() {
        this.routerAct.queryParams.subscribe(params => {
            this.type = params.type;
            this.IO.send({ token: this.token.viewFileMobile, params: { kpass: params.kpass } })
        });
    }
}
